import React from 'react';

import SectionContainer from 'components/Containers/SectionContainer';
import Label from 'components/form/Label/Label';
import { FlexContainer } from 'components/Containers/FlexContainer/FlexContainer';
import { Row } from 'components/Containers/Row/Row';
import AccountImprovedImage from 'style/_assets/notificationsAlerts/credit-report.png';
import IconArrowImage from 'style/_assets/icons/arrow-right-blue.svg';
import { Link } from 'components/navigation/Link/Link';

const QuaterlyReportNotificationView = props => {
  const { alertDetailsConfig, selectedAlertDetails } = props;
  const description = `You've been making progress`;
  const quarterlyReportLink = 'Go To Quarterly Report';
  const csLogo = props?.bureauLogo['CS_ETL'];

  return (
    <SectionContainer className="cmAlertsDetailsContainer notificationsAlertsDetails">
      <Row className="d-hide text-1 margB16">
        <Label type="H4">{selectedAlertDetails?.title}</Label>
      </Row>
      <Row>
        <FlexContainer column>
          <Label className="caption fontGray300">
            {`Reported on ${alertDetailsConfig?.date} to `}
            {csLogo}
          </Label>
          <div>
            <img
              className="margt20"
              src={AccountImprovedImage}
              alt="Account Improved"
            />
          </div>
          <Label type="H5" typeHeader={'h5'}>
            {description}
          </Label>
          <Label type="Body1" className="margT16 mBody-2">
            We’re happy to report you’ve made progress on your credit goals!
          </Label>
          <FlexContainer className="margt20 justify-between">
            <Link
              link={quarterlyReportLink}
              className="fontBlue100"
              to="/QuarterlyReport"
            >
              View My Quarterly Report
            </Link>
            <Link link={quarterlyReportLink} to="/QuarterlyReport">
              <img src={IconArrowImage} alt="View My Quaterly Report" />
            </Link>
          </FlexContainer>
        </FlexContainer>
      </Row>
    </SectionContainer>
  );
};

export default QuaterlyReportNotificationView;
